import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";
import React from "react";
import { StandardCancelButton, StandardDeleteButton } from "../../components/StandardButtons";

/**
 * DangerModal Component
 * Confirmation modal for dangerous actions like deletions
 * Provides a user-friendly way to confirm destructive operations
 * @param {Object} props - Component props
 * @param {Function} props.onSubmitHandler - Function to execute when confirmed
 * @param {string|number} props.id - Identifier for the item to be acted upon
 * @param {string} props.modalHeading - Text content to display in the modal body
 * @param {boolean} props.isOpen - Controls modal visibility
 * @param {Function} props.onOpen - Function to open the modal
 * @param {Function} props.onOpenChange - Function to handle modal open/close state changes
 * @returns {JSX.Element} Confirmation modal
 */
const DangerModal = ({
  onSubmitHandler,
  id,
  modalHeading,
  isOpen,
  onOpen,
  onOpenChange,
}) => {
  /**
   * Handle form submission and close modal
   * Executes the provided handler function and closes the modal
   * @param {Function} onClose - Function to close the modal
   */
  const submitHandler = async (onClose) => {
    await onSubmitHandler(id);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <ModalContent>
        {(onClose) => (
          <>
            {/* Modal Header */}
            <ModalHeader className="flex flex-col gap-1">
              Metric Data
            </ModalHeader>
            
            {/* Modal Body */}
            <ModalBody>
              <p>{modalHeading}</p>
            </ModalBody>
            
            {/* Modal Footer with Action Buttons */}
            <ModalFooter>
              <StandardCancelButton onPress={onClose} aria-label="Cancel deletion">
                Cancel
              </StandardCancelButton>
              <StandardDeleteButton onClick={() => submitHandler(onClose)} aria-label="Confirm deletion">
                Delete
              </StandardDeleteButton>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DangerModal;
